module.exports = __webpack_public_path__ + "static/Drow-b5551a5f3ac15fe05705dbddb8756d71.jpg";